var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "order-status",
      class: {
        "order-status--cancelled":
          _vm.order.current_status === _vm.ORDER_STATUS.CANCELLED,
        "order-status--delivered":
          _vm.order.current_status === _vm.ORDER_STATUS.SENT_TO_BUYER
      }
    },
    [
      _vm.order.current_status === _vm.ORDER_STATUS.CANCELLED
        ? [_vm._v("Canceled")]
        : _vm.order.current_status === _vm.ORDER_STATUS.SENT_TO_BUYER
        ? [_vm._v("Tickets Ready")]
        : [_vm._v("Processing")]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }